<template>
    <filter-exclusion-composable-checkpoint v-if="isFilterExclusion" :checkpoint-name="checkpointName" v-tooltipped:[tooltip] />
    <normal-composable-checkpoint v-else :checkpoint-name="checkpointName" v-tooltipped:[tooltip] />
</template>

<script>
import NormalComposableCheckpoint from "./NormalComposableCheckpoint";
import FilterExclusionComposableCheckpoint from "./FilterExclusionComposableCheckpoint";

import tooltipped from "@modules/JourneyBuilder/Directives/tooltipped";

import {checkpointDefinitions, filterExclusionCheckpoint} from "@modules/JourneyBuilder/Bricks/Checkpoints";

export default {
    name: "ComposableCheckpoint",
    components: {
        NormalComposableCheckpoint,
        FilterExclusionComposableCheckpoint
    },
    directives: {
        tooltipped
    },
    props: {
        'checkpointName': {
            type: String,
            required: true
        }
    },
    computed: {
        isFilterExclusion(){
            return this.checkpointName === filterExclusionCheckpoint.name;
        },
        tooltip(){
            return checkpointDefinitions[this.checkpointName].buildInformationTooltip();
        }
    }
}
</script>

<style scoped>

</style>